import { Grid } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import ApartmentIcon from '@material-ui/icons/Apartment';
import React from 'react';
import { useSelector } from 'react-redux';
import CardMessage from '../../../components/CardMessage/CardMessage';
import EmployeesListCard from '../../../components/EmployeesListCard';
import { AppState } from '../../../store';
import { CondominiumReducerData } from '../../../store/reducers/condominiumReducer';
import NotificationsCard from './components/NotificationsCard/NotificationsCard';
import OccurrencesStatusTabCard from './components/OccurrencesTabCard/OccurrencesStatusTabCard';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mainContentContainer: {
      overflowX: 'hidden',
      display: 'flex',
      alignItems: 'center',
      overflowY: 'auto',
      margin: 0,
      width: '100%',
      height: 'calc(100vh - 152px)',
      padding: theme.spacing(1),
    },

    contentMaxHeight: {
      height: '100%',
    },
  }),
);

const PunchCardManagement: React.FC = () => {
  const classes = useStyles();

  const { condominiumSelected }: CondominiumReducerData = useSelector(
    (state: AppState) => state.condominiumReducer,
  );

  return (
    <Grid className={classes.mainContentContainer} spacing={2} container>
      {condominiumSelected ? (
        <>
          <Grid
            className={classes.contentMaxHeight}
            item
            xs={12}
            sm={12}
            md={3}
          >
            <EmployeesListCard
              title="Folha de Ponto"
              titleTooltip="Clique no nome do funcionário para acessar a folha de ponto"
            />
          </Grid>
          <Grid
            className={classes.contentMaxHeight}
            item
            xs={12}
            sm={12}
            md={3}
          >
            <OccurrencesStatusTabCard />
          </Grid>
          <Grid
            className={classes.contentMaxHeight}
            style={{ paddingRight: 0 }}
            container
            spacing={2}
            item
            xs={12}
            sm={12}
            md={6}
          >
            <Grid style={{ height: '100%', padding: 0 }} item xs={12}>
              <NotificationsCard />
            </Grid>
            {/* <Grid
              style={{ height: '50%', paddingBottom: 0, paddingRight: 0 }}
              item
              xs={12}
            >
              <ChartsCard />
            </Grid> */}
          </Grid>
        </>
      ) : (
        <CardMessage
          icon={<ApartmentIcon style={{ fontSize: 130, opacity: 0.4 }} />}
          message="Selecione um condomínio"
        />
      )}
    </Grid>
  );
};

export default PunchCardManagement;
